
import { ClientPortalQrSettings } from "@/utils/sale-layouts/client-portal-qr-settings";
import { PaymentQrSettings, PaymentQrReferenceType } from "@/utils/sale-layouts/payment-qr-settings";
import AppCustomLangSelect from "@/components/CustomLanguageSelect.vue";
import AppPropSelectAutocomplete from "@/components/prop-select/PropSelectAutocomplete.vue";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getSaleMapPropSelectGroup } from "@/utils/prop-select/sale-map-prop-group";
import { ISelectItem } from "winfakt-vue-components";
import { DocumentLayoutLogoPosition } from "@/utils/documents/layout-logo";
import AppSelectPlacement from "./SelectPlacement.vue";
import AppSelectBankType from "@/components/bank/SelectBankType.vue";
import AppErrorMessageBox from "@/components/common/ErrorMessageBox.vue";
import Vue from "vue";
import { BankService } from "@/services/bank-service";
import { isStringNullOrWhitespace } from "@/utils/strings";
import { SaleLayoutLogoPosition } from "@/utils/sale-layouts/logo";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import { SaleLayoutFreeLine } from "@/utils/sale-layouts/free-line";
import { Field } from "@/utils/documents/field";
import { CustomTranslation } from "@/utils/custom-translation";
import { Condition } from "@/utils/condition/condition";
import { SaleFreeBlock } from "@/utils/sale-layouts/sale-free-block";


export default Vue.extend({
	data() {
		return {
			customReferenceLang: ""
		};
	},
	props: {
		clientPortalQrSettings: {
			type: Object as ()=>ClientPortalQrSettings,
			required: true
		},
		paymentQrSettings: {
			type: Object as ()=>PaymentQrSettings,
			required: true
		},
		layout: {
			type: Object as ()=>SaleLayout,
			required: true
		}
	},
	computed: {
		clientPortalQrPlacement():SaleLayoutLogoPosition | "null"{
			if (!this.clientPortalQrSettings.Show) {
				return "null";
			}
			return this.clientPortalQrSettings.Placement;
		},
		paymentQrPlacement():SaleLayoutLogoPosition | "null" {
			if (!this.paymentQrSettings.Show) {
				return "null";
			}
			return this.paymentQrSettings.Placement;
		},
		referenceTypeItems():ISelectItem<PaymentQrReferenceType>[] {
			return [
				{text: this.$ct("qr-payment-reference-types.Ogm").toString(), value: "Ogm"},
				{text: this.$ct("qr-payment-reference-types.SaleNumber").toString(), value: "SaleNumber"},
				{text: this.$ct("qr-payment-reference-types.Custom").toString(), value: "Custom"}
			];
		},
		isCustomReference():boolean {
			return this.paymentQrSettings.ReferenceType == "Custom";
		},
		saleMapProps():PropSelectGroup {
			return getSaleMapPropSelectGroup();
		},
		showEmptyBankErrorMessage():boolean {
			if (!this.paymentQrSettings.Show) {
				return false;
			}
			let bank = BankService.getTypes().find(b => b.ID == this.paymentQrSettings.BankID);
			if (!bank) {
				return false;
			}
			if (isStringNullOrWhitespace(bank.Iban) || isStringNullOrWhitespace(bank.Bic)) {
				return true;
			}
			return false;
		}
	},
	methods: {
		setClientPortalQrPlacement(value:DocumentLayoutLogoPosition | "null"){
			if (value == "null"){
				this.clientPortalQrSettings.Show = false;
			}else{
				this.clientPortalQrSettings.Show = true;
				this.clientPortalQrSettings.Placement = value;
				this.clientPortalQrSettings.X = 0;
				this.clientPortalQrSettings.Y = 0;
			}
		},
		setPaymentQrPlacement(value:DocumentLayoutLogoPosition | "null"){
			if (value == "null"){
				this.paymentQrSettings.Show = false;
			}else{
				this.paymentQrSettings.Show = true;
				this.paymentQrSettings.Placement = value;
				this.paymentQrSettings.X = 0;
				this.paymentQrSettings.Y = 0;
			}
		},
		setAutomaticPaymentQrPlacement(value:string){
			this.paymentQrSettings.Show = true;
			this.paymentQrSettings.Placement = value;
			this.paymentQrSettings.X = 0;
			this.paymentQrSettings.Y = 2;
			this.paymentQrSettings.Width = 20;
			this.paymentQrSettings.Height = 20;
		},
		addQrCode(){
			let line = new SaleLayoutFreeLine({Label: "QR-code"});
			line.Style.PaddingTop = 22;
			let c = new Condition({IsOr: false,Prop: "TotalOpen",Operator: 1, Value: ""});
			line.Conditions.push(c);
			this.setAutomaticPaymentQrPlacement(line.Key);
			this.layout.FreeLines.push(line);
			let block = new SaleFreeBlock({
				Height: 11,
				Width: 45,
				X: 25,
				Y: 2,
				Placement: line.Key as DocumentLayoutLogoPosition
			});
			let field = new Field(
				{Style: {Bold: true, FontSize: 11}}
			);
			let Translations = this.$ct("automations.qr-code");
			field.Text = new CustomTranslation({Translations,
				Fallback: ""});
			block.Lines.push(field);
			this.layout.FreeBlocks.push(block);
			this.$wf.notify(this.$ct("automations.messages.qr-ok").toString(), "success", 3000, "check");
		}
	},
	components: {
		AppSelectPlacement,
		AppSelectBankType,
		AppErrorMessageBox,
		AppCustomLangSelect,
		AppPropSelectAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
